import { useRouter } from 'nuxt/app';
import { LOCALE_CODE } from '@pkg/config/languages/localeCodes';

/**
 * Silently updates the browser URL to reflect the correct locale
 * @param newLocale - The locale code to update the URL to
 * @param currentPath - The current route path
 */
export const updateUrlLocale = (newLocale: string, currentPath: string): void => {
  if (!process.client) {
    return;
  }

  const localeCodes = Object.values(LOCALE_CODE);
  const localeRegex = new RegExp(`^/(${localeCodes.join('|')})`);
  const pathWithoutLocale = currentPath.replace(localeRegex, '');
  const newPath = `/${newLocale}${pathWithoutLocale}`;

  const router = useRouter();
  router.replace(newPath);
};
